import classNames from 'classnames/bind';
import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import styles from './common.module.scss';

import actions from '@/actions';
import FieldRow from '@/components/ui/FieldRow';
import { FieldNumber } from '@/components/ui/kit/Field';
import { roundToDecimal } from '@/utils/Formatter';

const cx = classNames.bind(styles);

const Command = ({ index, data: command }) => {
  const dispatch = useDispatch();
  const domRefs = useRef({
    distance: useRef(),
  }).current;

  useEffect(() => {
    domRefs.distance.current.value = command.data.distance.toFixed(1);
  }, [command.data]);

  const handleBlur = (e) => {
    const name = e.target.name;
    const value = roundToDecimal(e.target.value);
    dispatch(actions.mission.updateCommand(index, name, value));
  };

  return (
    <div className={cx('container')}>
      <FieldRow label="Distance" unit="m">
        <FieldNumber ref={domRefs.distance} name="distance" min={0} onBlur={handleBlur} />
      </FieldRow>
    </div>
  );
};

export default Command;
